import React, { useState } from "react";
import hostHomeBg from "../../../assets/images/others/host-side-images/hostHomeBg.png";
import hostHeroImage from "../../../assets/images/others/host-side-images/hostHeroImage.png";
import { ReactComponent as NoEvents } from "../../../assets/images/svgs/no-events.svg";
import { ReactComponent as FilterBy } from "../../../assets/images/svgs/filterBy.svg";
import exploreEvents from "../../../assets/images/others/host-side-images/exploreEvents.png";
import favIcon from "../../../assets/images/svgs/favIcon.svg";
import locationIcon from "../../../assets/images/svgs/locationIcon.svg";
import iconOne from "../../../assets/images/svgs/iconOne.svg";
import iconTwo from "../../../assets/images/svgs/iconTwo.svg";
import iconThree from "../../../assets/images/svgs/iconThree.svg";
import { FiSearch } from "react-icons/fi";
import FilterDrawer from "../../../components/drawers/host-side/FilterDrawer";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "../../../utils/helpers/enums/routes";
import AttendeeBreadcrumb, { AttendeBreadcrumbLink } from "../../../components/breadcrumbs/AttendeeBreadcrumb";

export type Experience = {
  id: number;
  date: string;
  month: string;
  title: string;
  location: string;
  attendees: number;
  image: string;
  attendeesAvatars: string[];
  category: string; // "Workshop" or "Session"
  timeFilter: "This Week" | "This Month" | "";
  dateStatus: "Upcoming" | "Past";
};

// Dummy data for events (including both upcoming and past)
const experiences: Experience[] = [
  {
    id: 1,
    date: "10",
    month: "JUNE",
    title: "How to Improve Your Communication and Social Life",
    location: "Radius Gallery • Santa Cruz, CA",
    attendees: 20,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Workshop",
    timeFilter: "This Week",
    dateStatus: "Upcoming",
  },
  {
    id: 2,
    date: "12",
    month: "JULY",
    title: "Networking for Young Professionals",
    location: "Downtown Hub • New York, NY",
    attendees: 35,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Session",
    timeFilter: "This Month",
    dateStatus: "Upcoming",
  },
  {
    id: 3,
    date: "15",
    month: "JUNE",
    title: "Public Speaking Essentials",
    location: "Community Center • Chicago, IL",
    attendees: 25,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Workshop",
    timeFilter: "This Month",
    dateStatus: "Upcoming",
  },
  {
    id: 4,
    date: "20",
    month: "JULY",
    title: "Mastering Leadership Skills",
    location: "Tech Hub • San Francisco, CA",
    attendees: 30,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Session",
    timeFilter: "This Week",
    dateStatus: "Upcoming",
  },
  // Past experiences dummy data
  {
    id: 5,
    date: "05",
    month: "MAY",
    title: "Past Workshop Event",
    location: "Old Venue • Boston, MA",
    attendees: 40,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo, iconThree],
    category: "Workshop",
    timeFilter: "This Week",
    dateStatus: "Past",
  },
  {
    id: 6,
    date: "08",
    month: "APRIL",
    title: "Past Session Event",
    location: "Historic Hall • Los Angeles, CA",
    attendees: 50,
    image: exploreEvents,
    attendeesAvatars: [iconOne, iconTwo],
    category: "Session",
    timeFilter: "This Month",
    dateStatus: "Past",
  },
];



/** AttendeExperiences Component */
const AmbassadorExperiences = () => {
  const navigate = useNavigate();

  // Upcoming filters
  const [selectedUpcomingCategory, setSelectedUpcomingCategory] = useState<string>("All");
  const [selectedUpcomingTimeFilter, setSelectedUpcomingTimeFilter] = useState<string>("");

  // Past filters
  const [selectedPastCategory, setSelectedPastCategory] = useState<string>("All");
  const [selectedPastTimeFilter, setSelectedPastTimeFilter] = useState<string>("");

  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  // Filter upcoming experiences based on upcoming filters
  const filteredUpcoming = experiences.filter(
    (exp) =>
      exp.dateStatus === "Upcoming" &&
      (selectedUpcomingCategory === "All" || exp.category === selectedUpcomingCategory) &&
      (selectedUpcomingTimeFilter === "" || exp.timeFilter === selectedUpcomingTimeFilter)
  );

  // Filter past experiences based on past filters
  const filteredPast = experiences.filter(
    (exp) =>
      exp.dateStatus === "Past" &&
      (selectedPastCategory === "All" || exp.category === selectedPastCategory) &&
      (selectedPastTimeFilter === "" || exp.timeFilter === selectedPastTimeFilter)
  );

  /** Breadcrumb links */
  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.attendeeHome },
    {
      title: "Experiences",
      path: siteRoutes.attendeeExperiences,
    },
  ];

  return (
    <div className="container min-h-screen mb-10">
      <AttendeeBreadcrumb links={breadcrumbLinks} />
      {/* Upcoming Experiences Section */}
      <h2 className="text-2xl font-bold mb-4">Attend one Experiences</h2>
      {/* Upcoming Filter Controls */}
      <div className="flex flex-wrap items-center justify-between gap-5">
        <div className="flex flex-wrap gap-5 py-5">
          <div className="flex space-x-4 md:space-x-10 pb-2">
            {["All", "Workshop", "Session"].map((tab) => (
              <button
                key={tab}
                className={`text-base font-semibold pb-1 ${
                  selectedUpcomingCategory === tab
                    ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                    : "text-grayText hover:text-lightBlueColor"
                }`}
                onClick={() => setSelectedUpcomingCategory(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="border-l pl-3 md:pl-5">
            <div className="flex space-x-4 md:space-x-10 pb-2">
              {["This Week", "This Month"].map((tab) => (
                <button
                  key={tab}
                  className={`text-base font-semibold pb-1 flex items-center ${
                    selectedUpcomingTimeFilter === tab
                      ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                      : "text-grayText hover:text-lightBlueColor"
                  }`}
                  onClick={() =>
                    setSelectedUpcomingTimeFilter(selectedUpcomingTimeFilter === tab ? "" : tab)
                  }
                >
                  {tab}
                  {selectedUpcomingTimeFilter === tab && (
                    <span className="ml-2 text-sm text-red-500 cursor-pointer">✕</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* Search and Filter Drawer */}
        <div className="flex flex-wrap gap-4 items-center">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FiSearch className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="search"
              placeholder="Find Resource.."
              className="w-full pl-10 pr-4 py-2 h-[51px] rounded-lg border border-inputsBorderColor outline-none"
            />
          </div>
          <button onClick={toggleDrawer} className="text-labelTextColor flex gap-1 font-medium">
            Filter by <FilterBy />
          </button>
        </div>
      </div>

      {/* Upcoming Experiences Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
        {filteredUpcoming.map((exp) => (
          <div
            key={exp.id}
            onClick={() => navigate(siteRoutes.experiencesDetailAttendee)}
            className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer"
          >
            <div className="relative">
              <img
                src={exp.image}
                alt={exp.title}
                className="w-full h-32 object-cover rounded-xl"
              />
              <div className="absolute top-2 left-2 bg-white text-center p-2 rounded-md">
                <span className="block text-sm font-bold text-primaryBlueText">
                  {exp.date}
                </span>
                <span className="block text-xs text-primaryBlueText">{exp.month}</span>
              </div>
            </div>
            <div className="py-2">
              <h3 className="text-lg font-semibold text-blackie">{exp.title}</h3>
              <div className="flex items-center mt-2">
                <div className="flex -space-x-2">
                  {exp.attendeesAvatars.map((avatar, index) => (
                    <img
                      key={index}
                      src={avatar}
                      alt="Attendee"
                      className="w-7 h-7 rounded-full border-2 border-white"
                    />
                  ))}
                </div>
                <span className="ml-2 text-sm text-darkYellowText">+{exp.attendees} Going</span>
              </div>
              <p className="text-base text-[#807A7A] mt-2 flex items-center gap-2">
                <img src={locationIcon} alt="Location" /> {exp.location}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Past Experiences Section */}
      <div className="mt-10">
        <h2 className="text-2xl font-bold mb-4">Past Experiences</h2>
        {/* Past Filter Controls */}
        {/* <div className="flex flex-wrap gap-5 py-5">
          <div className="flex space-x-4 md:space-x-10 pb-2">
            {["All", "Workshop", "Session"].map((tab) => (
              <button
                key={tab}
                className={`text-base font-semibold pb-1 ${
                  selectedPastCategory === tab
                    ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                    : "text-grayText hover:text-lightBlueColor"
                }`}
                onClick={() => setSelectedPastCategory(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="border-l pl-3 md:pl-5">
            <div className="flex space-x-4 md:space-x-10 pb-2">
              {["This Week", "This Month"].map((tab) => (
                <button
                  key={tab}
                  className={`text-base font-semibold pb-1 flex items-center ${
                    selectedPastTimeFilter === tab
                      ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                      : "text-grayText hover:text-lightBlueColor"
                  }`}
                  onClick={() =>
                    setSelectedPastTimeFilter(selectedPastTimeFilter === tab ? "" : tab)
                  }
                >
                  {tab}
                  {selectedPastTimeFilter === tab && (
                    <span className="ml-2 text-sm text-red-500 cursor-pointer">✕</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div> */}

        {/* Past Experiences Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
          {filteredPast.map((exp) => (
            <div
              key={exp.id}
              onClick={() => navigate(siteRoutes.experienceDetail)}
              className="p-3 bg-white rounded-xl border border-borderColor cursor-pointer"
            >
              <div className="relative">
                <img
                  src={exp.image}
                  alt={exp.title}
                  className="w-full h-32 object-cover rounded-xl"
                />
                <div className="absolute top-2 left-2 bg-white text-center p-2 rounded-md">
                  <span className="block text-sm font-bold text-primaryBlueText">
                    {exp.date}
                  </span>
                  <span className="block text-xs text-primaryBlueText">{exp.month}</span>
                </div>
              </div>
              <div className="py-2">
                <h3 className="text-lg font-semibold text-blackie">{exp.title}</h3>
                <div className="flex items-center mt-2">
                  <div className="flex -space-x-2">
                    {exp.attendeesAvatars.map((avatar, index) => (
                      <img
                        key={index}
                        src={avatar}
                        alt="Attendee"
                        className="w-7 h-7 rounded-full border-2 border-white"
                      />
                    ))}
                  </div>
                  <span className="ml-2 text-sm text-darkYellowText">+{exp.attendees} Going</span>
                </div>
                <p className="text-base text-[#807A7A] mt-2 flex items-center gap-2">
                  <img src={locationIcon} alt="Location" /> {exp.location}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <FilterDrawer isOpen={drawerOpen} onClose={toggleDrawer} /> */}
    </div>
  );
};

export default AmbassadorExperiences;